import { Component } from '@angular/core';
import { BreadcrumbRouterComponent, RowComponent } from '@coreui/angular-pro';

@Component({
    selector: 'app-default-breadcrumb',
    imports: [
        BreadcrumbRouterComponent,
        RowComponent
    ],
    templateUrl: './default-breadcrumb.component.html'
})
export class DefaultBreadcrumbComponent {}
